module.exports = __webpack_public_path__ + "img/dischem_logo.4ce37963.svg";